import { DEFAULT_PAPER_WIDTH } from '@constants';
import { Paper } from '@mui/material';
import React, { createContext, ReactNode, useContext, useState } from 'react';

interface PaperWidthContextType {
  paperWidth: number;
  setPaperWidth: (width: number) => void;
}

const PaperWidthContext = createContext<PaperWidthContextType | undefined>(undefined);

export const usePaperWidthContext = () => {
  const context = useContext(PaperWidthContext);
  if (!context) {
    throw new Error('usePaperWidthContext must be used within a PaperWidthProvider');
  }
  return context;
};

interface PaperWidthProviderProps {
  children: ReactNode;
}

export const PaperWidthProvider: React.FC<PaperWidthProviderProps> = ({ children }) => {
  const [paperWidth, setPaperWidth] = useState(DEFAULT_PAPER_WIDTH);

  return (
    <PaperWidthContext.Provider value={{ paperWidth, setPaperWidth }}>
      <Paper sx={{ width: paperWidth, maxWidth: paperWidth }}>{children}</Paper>
    </PaperWidthContext.Provider>
  );
};
